import { jsx as _jsx } from "react/jsx-runtime";
import { CookieConsent } from "@cinch-nx/cookie-consent";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import useCookieModalOpen from "../hooks/cookie-modal-open.hook";
var CookieConsentWrapper = function() {
    var ref = useCookieModalOpen(), isPreferencesModalOpen = ref.isPreferencesModalOpen, setIsPreferencesModalOpen = ref.setIsPreferencesModalOpen;
    var setHasLoadedScripts = useAnalytics(function(s) {
        return s.setHasLoadedScripts;
    });
    var ref1 = useState(0), routeCount = ref1[0], setRouteCount = ref1[1];
    var router = useRouter();
    var incrementRouteCount = useCallback(function() {
        setRouteCount(routeCount + 1);
    }, [
        routeCount
    ]);
    useEffect(function() {
        router.events.on("routeChangeComplete", incrementRouteCount);
        return function() {
            router.events.off("routeChangeComplete", incrementRouteCount);
        };
    }, [
        router.events,
        incrementRouteCount
    ]);
    return /*#__PURE__*/ _jsx(CookieConsent, {
        count: routeCount,
        setLoaded: setHasLoadedScripts,
        setIsPreferencesModalOpen: setIsPreferencesModalOpen,
        isPreferencesModalOpen: isPreferencesModalOpen
    });
};
export default CookieConsentWrapper;
